import React from "react";

/**
 * Renders a header with the Dataplor logo
 * @param headerText - Text to display in the header
 * @returns React node with header text and logo
 */
export const renderHeaderWithLogo = (
  headerText: string,
  logoSrc: string = "/images/dataplor_logo.svg"
): JSX.Element => {
  return React.createElement(
    "div",
    { style: { display: "flex", alignItems: "center", gap: "4px" } },
    React.createElement("div", { style: { fontWeight: "bold" } }, headerText),
    React.createElement("img", {
      src: logoSrc,
      alt: "Kuebiko Logo",
      style: { width: "16px", height: "16px" },
    })
  );
};
